import {
  GatsbyImage,
  getImage,
  ImageDataLike,
  StaticImage,
} from 'gatsby-plugin-image';
import getYouTubeID from 'get-youtube-id';
import { PostEntryProps } from '../types';

export default function PostFeaturedImage({
  post,
  fallback,
  className = '',
  embed = false,
}: {
  post: PostEntryProps;
  fallback?: boolean;
  className?: string;
  embed?: boolean;
}) {
  if (embed) {
    const videoUrl = post.storyDetails?.videoUrl || post.postDetails?.videoUrl;
    const youtubeId = videoUrl ? getYouTubeID(videoUrl) : null;
    if (youtubeId) {
      return (
        <div className={`${className}`}>
          <div className="post-thumbnail">
            <iframe
              width="560"
              height="315"
              src={`https://www.youtube-nocookie.com/embed/${youtubeId}`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      );
    }
  }

  const wpLocalFile = post.featuredImage?.node?.localFile;
  const wpRemoteFile = post.featuredImage?.node?.sourceUrl;
  const wpYoutubeImage = post.youtubeImage;

  const gatsbyImageData =
    wpYoutubeImage || wpLocalFile
      ? getImage((wpYoutubeImage || wpLocalFile) as ImageDataLike)
      : null;

  if (gatsbyImageData) {
    return (
      <div className={`${className}`}>
        <GatsbyImage image={gatsbyImageData} alt={post.title} />
      </div>
    );
  }

  if (wpRemoteFile) {
    return (
      <div className={`${className}`}>
        <div className="post-thumbnail">
          <img
            src={wpRemoteFile}
            alt={post.title}
            sizes={post.featuredImage?.node?.sizes}
            srcSet={post.featuredImage?.node?.srcSet}
            width={post.featuredImage?.node?.mediaDetails?.width}
            height={post.featuredImage?.node?.mediaDetails?.height}
            loading="lazy"
          />
        </div>
      </div>
    );
  }

  if (fallback) {
    return (
      <div className={`${className}`}>
        <StaticImage
          src="../images/placeholder.jpg"
          alt=""
          aspectRatio={16 / 9}
          layout="fullWidth"
        />
      </div>
    );
  }

  return null;
}
